// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2SFHv","prefix":"styles_prefix__5zlcB","postfix":"styles_postfix__4elgw"};